import { render, staticRenderFns } from "./upgrade.vue?vue&type=template&id=4a400aba&scoped=true&"
import script from "./upgrade.vue?vue&type=script&lang=js&"
export * from "./upgrade.vue?vue&type=script&lang=js&"
import style0 from "./upgrade.vue?vue&type=style&index=0&id=4a400aba&prod&lang=less&scoped=true&"
import style1 from "./upgrade.vue?vue&type=style&index=1&id=4a400aba&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a400aba",
  null
  
)

export default component.exports